<template>
  <div id="app" class="min-h-screen bg-beige-50">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Main app component with minimal setup
</script>

<style scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style> 